$(document).ready(function() {

    const forms = document.querySelectorAll('form');

    forms.forEach(form => {

        // on form submission, disable the submit button to prevent double submission
        form.addEventListener('submit', function (e) {
            const submitButton = form.querySelector('button[type=submit], input[type=submit]');
            
            if (submitButton) {
                submitButton.disabled = true;
                submitButton.parentElement.classList.add('disabled'); // Optional: add a disabled class for styling
                submitButton.value = 'Submitting...'; // Optional: update button text
            }
        });
    });

});